// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/MessagingChatClientes_LookupResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response contract for POST /config/messaging_chat_clientes/lookup.
 *
 * The dados payload tells the inbox UI whether the identifier is already linked
 * to one or more clientes, plus a list of auto-match candidates when no link
 * exists yet.
 */
import type { MessagingChatClientes_AutoMatchCandidateRow } from './MessagingChatClientes_AutoMatchCandidateRow'
import type { MessagingChatClientes_ClienteRow } from './MessagingChatClientes_ClienteRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface MessagingChatClientes_LookupResponseDados {
linked: boolean
clientes: MessagingChatClientes_ClienteRow[]
auto_match_candidates: MessagingChatClientes_AutoMatchCandidateRow[]
}

export type MessagingChatClientes_LookupResponse = ApiResponse<MessagingChatClientes_LookupResponseDados>;

registerResponseContract('MessagingChatClientes_LookupResponse', {
  linked:                { type: 'boolean', required: true },
  clientes: {
    type: 'array',
    required: true,
    items: {
      cliente_id:             { type: 'number',  required: true },
      cliente_nome:           { type: 'string',  required: true },
      cliente_franquia_id:    { type: 'number',  required: false },
      cliente_telefone:       { type: 'string',  required: false },
      cliente_ddd:            { type: 'string',  required: false },
      cliente_ddi:            { type: 'string',  required: false },
      cliente_bairro:         { type: 'string',  required: false },
      has_orcamento:          { type: 'boolean', required: false },
      has_compromisso_aberto: { type: 'boolean', required: false },
      is_fidelizado:          { type: 'boolean', required: false },
      franquia:               { type: 'string',  required: false },
      link_type:              { type: 'string',  required: true },
      chat_cliente_id:        { type: 'number',  required: true },
    },
  },
  auto_match_candidates: {
    type: 'array',
    required: true,
    items: {
      cliente_id:          { type: 'number',  required: true },
      cliente_nome:        { type: 'string',  required: true },
      cliente_franquia_id: { type: 'number',  required: false },
      cliente_categoria:   { type: 'string',  required: false },
      franquia:            { type: 'string',  required: false },
    },
  },
})
